export const option: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 6000,
}
